import { Component, ElementRef, HostListener, Input, OnInit, SimpleChanges,ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators} from '@angular/forms';
import { AspCustomerListService } from './asp-customer-list.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AspLoadingService } from '../asp-loading/asp-loading.service';
import { SideBarJobcardService } from '../side-bar-jobcard/side-bar-jobcard.service';
import { ToastrService } from 'ngx-toastr';



@Component({
  selector: 'app-asp-customer-list',
  templateUrl: './asp-customer-list.component.html',
  styleUrls: ['./asp-customer-list.component.scss'],

})
export class AspCustomerListComponent implements OnInit {

   @ViewChild('businessNameField') businessNameField!: ElementRef;
  @ViewChild('stateField') stateField!: ElementRef;
  @ViewChild('nameField') nameField!: ElementRef;
  @ViewChild('mobileField') mobileField!: ElementRef;

  gstDetails = false;     // Hide GST slider by default
  hasGst: boolean = true;
  gstNumber: string = "";
  showGstSecondSlider: boolean = false;
  showBusinessInfoSlider: boolean = false;
  businessName: string = '';
  showAddressSlider: boolean = false;
  addressLine1: string = '';
  addressLine2: string = '';
  pincode: string = '';
  city: string = '';
  selectedImage: string = '';
  stateSliderOpen = false;
  isJobCardSidebarOpen = false;
  selectedState: string = '';
  stateData: any[] = [];
  filteredStates: any[] = [];
  carDetailsForm: FormGroup;
  vehicleForm1: FormGroup;
  customerGstForm: FormGroup;
  customerList: any[] = [];

  addressForm: FormGroup;
  gstNumberform: FormGroup;
  searchTextStates = ''; 
  isVisible = false;
  customerID: string | null = null;
  // customerName: any;
  currentTime = new Date();
  showBookingPopup = false;
  successIcon: string = '../../../../assets/icons/icons8-ok.gif';
  isConfirmationSidebarOpen = false;
  isManualSelection: boolean = false;
  formSubmitted = false;
  jobCard: any = {}
  // jobCard: { 
  //   make: any; 
  //   registrationNumber: any; model: any; variant: any; mfgYear: any; fuelType: any; vin: any; ExistingCustomer: any; };
  @Input() bookingId!: string;
  @Input() name: string | null = null;
  @Input() phoneNumber: string | null = null;
  jobCardDetails = true;
  showServiceHistory: boolean;
  isExistingCustomer: any;
  regNo: string;
  vehicleData: any = [];
  vehicleInfo: boolean = false;
  isCreateCustomerSliderOpen: boolean = false;
  selectedMake: string;
  selectedModel: string;
  selectedYear: string;
  selectedVariant: string;
  customerForm:FormGroup;
  searchText: string = '';
filteredCustomerList: any[] = [];
originalCustomerList: any[] = []; 
emptyList: any = 'assets/images/no-cart.png';

  car =  {
    regNumber: '',
    vin: localStorage.getItem('vin') || '',
    engineNumber: '',
    odometerReading: '',
    lastServiceDate: '',
    selectedServices: [] as string[],
  }
  
  customer = {
    name: '',
    mobile: '',
    email: '',
    rateCardApplicable: '',
  }
  param: any;
  ratecardTypes: any;

  constructor(
     private fb: FormBuilder,
        private _formBuilder: FormBuilder,
        private aspCustomerListService: AspCustomerListService,
        private elementRef: ElementRef,
        private router: Router,
        private route: ActivatedRoute,
        private aspLoadingService: AspLoadingService,
        private sideBarJobcardService: SideBarJobcardService,
        public toastr: ToastrService,
  ) { 
    this.customerGstForm = this._formBuilder.group({
      "businessName":['', [Validators.required, Validators.minLength(2)]],
      "gstNumber": [this.gstNumber,Validators.required,Validators.pattern(/^[0-9A-Z]{15}$/)]
    ,
      "address" : ['', [Validators.required, Validators.minLength(2)]], 
    "state": [this.selectedState, Validators.required],
    
  });

  this.customerForm = this._formBuilder.group({
    "name": ['', [Validators.required, Validators.pattern('^[A-Za-z ]+$')]],
    "mobile": ['', [Validators.required, Validators.pattern('^[0-9]{10}$')]],
    "email": [''],
    'rateCardApplicable': ['', Validators.required]
  });

  this.addressForm = this._formBuilder.group({
    addressLine1: [''],
    addressLine2: [''], 
    pincode: [''],
    city: ['']
  });
  }
  get cgf() {
    return this.customerGstForm.controls;
  }
  get gst(){
    return this.gstNumberform.controls;
  }
  get af() {
    return this.addressForm.controls;
  }


  

  ngOnInit(): void {

        // Initialize form with phoneNumber and name from Input properties
        this.vehicleForm1 = this._formBuilder.group({
          regNo: [this.regNo ||'', [Validators.required,Validators.minLength(13), Validators.maxLength(13)]],
         // odometer: ['', [Validators.required]],
         rowKey: [''],
         variantKey: [''],
         // phoneNumber: [this.phoneNumber || '', [Validators.required, Validators.minLength(10)]],
         // name: [this.name || '', Validators.required]
       });
       // Initialize vehicleForm1 instead of vehicleForm
        this.vehicleForm1.get('regNo')?.valueChanges.subscribe(value => {
          if (value) {
            const formattedValue = this.formatRegNo(value);
            // console.log("format regno----",formattedValue);
            this.vehicleForm1.get('regNo')?.setValue(formattedValue, { emitEvent: false });
            // console.log(" this.vehicleFor===========",this.vehicleForm1.get('regNo')?.setValue(formattedValue, { emitEvent: false }));
          }
        });

       this.vehicleData = JSON.parse(localStorage.getItem("vehicleData"));
       if(this.vehicleData){
         this.vehicleInfo = true;
       }else{
         this.vehicleInfo = false;
       }
       if(localStorage.getItem('customer-list') && localStorage.getItem('customer-list') == '1' ){
        // this.isManualSelection = true;
        this.isConfirmationSidebarOpen = true;
        localStorage.removeItem('customer-list'); 
      }
      if (!this.bookingId ){
        // Fetch details from localStorage
        this.selectedMake = localStorage.getItem('selectedMake') || '';
        this.selectedModel = localStorage.getItem('selectedModel') || '';
        this.selectedVariant = localStorage.getItem('variant') || '';
        this.selectedYear = localStorage.getItem('selectedYear') || '';
  
        this.jobCard = {
          make: this.selectedMake,
          model: this.selectedModel,
          variant: this.selectedVariant,
          mfgYear: this.selectedYear,
          fuelType: localStorage.getItem('fuelType') || '',
          vin: localStorage.getItem('vin') || ''
        };
  
        // Automatically populate the form
        this.vehicleForm1.patchValue({
          make: this.selectedMake,
          model: this.selectedModel,
          variant: this.selectedVariant,
          year: this.selectedYear
        });
        
      }
      this.fetchAllCustomers();
      this.fetchRateCardTypes();
  }
formatRegNo(value: string): string {
  value = value.replace(/\s+/g, '').toUpperCase(); // Remove all spaces and convert to uppercase

  if (value.length >= 10) {
    return `${value.slice(0, 2)} ${value.slice(2, 4)} ${value.slice(4, 6)} ${value.slice(6, 10)}`;
  } else if (value.length >= 8) {
    return `${value.slice(0, 2)} ${value.slice(2, 4)} ${value.slice(4, 6)} ${value.slice(6)}`;
  } else if (value.length >= 6) {
    return `${value.slice(0, 2)} ${value.slice(2, 4)} ${value.slice(4)}`;
  } else if (value.length >= 4) {
    return `${value.slice(0, 2)} ${value.slice(2)}`;
  } else {
    return value;
  }
}

    ngOnChanges(changes: SimpleChanges): void {
      if (changes.phoneNumber && changes.phoneNumber.currentValue) {
        this.vehicleForm1.patchValue({
          phoneNumber: changes.phoneNumber.currentValue
        });
      }
      if (changes.name && changes.name.currentValue) {
        this.vehicleForm1.patchValue({
          name: changes.name.currentValue
        });
      }
    }
// ==================GST 1ST-SIDEBAR-CODE===============
openGstSlider(){
  this.gstDetails = true;
}
closeGstSlider() {
  this.gstDetails = false;  
  this.isJobCardSidebarOpen = true;
}
connewCustomer() {
  // this.jobCardDetails = false; 
  // this.customerDetailsANDcarDetails=true
  // this.gstDetails = true; 
  this.isVisible = true;
  this.isJobCardSidebarOpen =true;
}
confirmDetails(){
  this.isJobCardSidebarOpen =false;
  this.gstDetails = true; 
  this.isConfirmationSidebarOpen = false;
}

skipForNow() {
  this.gstDetails = false;  
  this.showGstSecondSlider = false;
}

selectGstOption(isGstAvailable: boolean) {
  this.hasGst = isGstAvailable;  // ✅ Fix: Directly use parameter
}

// continueNextStep() {
//   if (this.hasGst !== null) {
//       this.gstDetails = false;
//   }
//   if (this.hasGst) {
//         this.showGstSecondSlider = true;  // Show second slider
//       }
//       if (this.hasGst === false) {
//         this.isConfirmationSidebarOpen = true; // Show final confirmation
//       }
    
// }
// continueNextStep() {
//   if (this.hasGst !== null) {
//     this.gstDetails = false;
//   }

//   // When user selects "Yes, I have GST Number"
//   if (this.hasGst === true) {
//     this.showGstSecondSlider = true;  // Open second GST input slider
//     this.isCreateCustomerSliderOpen = true; // Ensure it's closed
//   }

//   // When user selects "I don’t have GST Number"
//   if (this.hasGst === false) {
//     this.showGstSecondSlider = false; // Ensure GST slider is closed
//     this.isCreateCustomerSliderOpen = true;  // ✅ Open create customer slider
//   }
// }

continueNextStep() {
  // Always close GST details and open the customer creation slider
  this.gstDetails = false;
  this.isCreateCustomerSliderOpen = true;

  // Toggle GST second slider based on GST selection
  if (this.hasGst === true) {
    this.showGstSecondSlider = true;
  } else if (this.hasGst === false) {
    this.showGstSecondSlider = false;
  }

  // ✅ Do NOT call confirmGarageCustomerDetails() here
}



closeGstDetails(){
  this.gstDetails = false
}

toggleConfirmationSidebar() {
  this.isConfirmationSidebarOpen = !this.isConfirmationSidebarOpen;
  // this.gstDetails = !this.isConfirmationSidebarOpen;
  if (!this.isConfirmationSidebarOpen) {
    this.isVisible = true;
    this.ngOnInit();
  }
}


// ================= GST-2ND SLIDER============
 
// Close Second Slider
closeSecondSlider() {
  
  this.showGstSecondSlider = false;
  this.gstDetails = true;
  this.isCreateCustomerSliderOpen = false;
}
// Proceed to Next Step
proceedToNextStep(): void {
  if (this.gstNumber.length === 15) {
    this.customerGstForm.patchValue({ gstNumber: this.gstNumber });
    this.openBusinessSlider();
  }
}



openBusinessSlider() {
  this.showBusinessInfoSlider = true;
  this.showGstSecondSlider = false;  // Hide GST slider

}

closeBusinessSlider() {
  this.showBusinessInfoSlider = false;
  this.showGstSecondSlider = true;
}


// validateGstInput() {
//   if (this.gstNumber.length > 15) {
//       this.gstNumber = this.gstNumber.substring(0, 15);
//       console.log("gstNumber---",this.gstNumber);
//   }
// }
validateGstInput() {
  const control = this.gstNumberform.get('gstNumber');
  const value = control?.value?.toUpperCase() || '';
  control?.setValue(value, { emitEvent: false });
  if (this.gstNumber.length > 15) {
    this.gstNumber = this.gstNumber.substring(0, 15);
    // console.log("gstNumber---",this.gstNumber);
}
}

// ==============end business -slider-gst=======

// =========stats-selection======
openStateSlider(): void {
  this.stateSliderOpen = true;
  this.fetchStates();
}

closeStateSlider(): void {
  this.stateSliderOpen = false;
}

fetchStates(): void {
  this.aspCustomerListService.getStateList().subscribe(
    (response) => {
      if (response.code === 200) {
        this.stateData = response.data;
        this.filteredStates = [...this.stateData]; // Ensure filteredStates has full objects
      } else {
        console.warn('Error fetching states:', response.message);
      }
    },
    (error) => {
      console.error('API Error while fetching states:', error);
    }
  );
}

filterStates(): void {
  if (!this.searchTextStates) {
    this.filteredStates = [...this.stateData];
  } else {
    this.filteredStates = this.stateData.filter(state =>
      state.name.toLowerCase().includes(this.searchTextStates.toLowerCase())
    );
  }
}
clearStateSearch(): void {
  this.searchTextStates = '';
  this.filteredStates = [...this.stateData];
}

selectState(state: any): void {
  this.selectedState = state.name; // just the name as string
  // console.log("Selected state ----", this.selectedState);

  this.customerGstForm.patchValue({ state: this.selectedState });
  this.stateSliderOpen = false;

  // console.log("Form value after patch ----", this.customerGstForm.value);
}



// ===============gst address slide-sidre==================
// openAddressSlider() {
//   if ((this.customerGstForm.get('businessName')?.invalid || this.customerGstForm.get('state')?.invalid) || this.customerForm.get('name')?.invalid || this.customerForm.get('mobile')?.invalid) {
//     this.customerGstForm.get('businessName')?.markAsTouched();
//     this.customerGstForm.get('state')?.markAsTouched();
//     this.customerForm.get('name')?.markAsTouched();
//     this.customerForm.get('mobile')?.markAsTouched();
//     return


//   }
//       // Proceed if valid
//   console.log("Proceeding to address slider...");
//   this.showBusinessInfoSlider = false;
//   this.showAddressSlider = true;

// }

openAddressSlider() {
  const fieldMap = [
    { control: this.customerGstForm.get('businessName'), id: 'businessName' },
    { control: this.customerGstForm.get('state'), id: 'state' },
    { control: this.customerForm.get('name'), id: 'name' },
    { control: this.customerForm.get('mobile'), id: 'mobile' },
        { control: this.customerForm.get('rateCardApplicable'), id: 'rateCardApplicable' }

  ];

  fieldMap.forEach(field => field.control?.markAsTouched());

  // Scroll to the first invalid field
  const firstInvalid = fieldMap.find(field => field.control?.invalid);
  if (firstInvalid) {
    const el = document.getElementById(firstInvalid.id);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'center' });
      el.focus();
    }
    return; // Stop here until all are fixed
  }
  // Proceed if all valid
  // console.log("Proceeding to address slider...");
  this.showBusinessInfoSlider = false;
  this.showAddressSlider = true;
}


// Close Address Slider
closeAddressSlider() {
  this.showAddressSlider = false;
  this.showBusinessInfoSlider = true;
}

saveAddressDetails() {
  if (this.addressForm.valid) {
    const addressDetails = this.addressForm.value;

    this.showAddressSlider = false;
    this.gstDetails = false;
    this.showGstSecondSlider = false;
    this.confirmGarageCustomerDetails();
    
    // this.customerDetailsANDcarDetails = true;
    // this.jobCardDetails = false;

    // console.log('✅ Address saved:', addressDetails);
  } else {
    console.warn('❌ Address form is invalid:', this.addressForm.errors);
    this.addressForm.markAllAsTouched();
    
  }
}

onCreateCustomer() {
  if (this.customer?.name && this.customer?.mobile) {
    // Patch the values into the reactive form before sending
    this.customerForm.patchValue({
      name: this.customer.name,
      phone: this.customer.mobile,
      email: this.customer.email || '',
      rateCardApplicable: this.customer.rateCardApplicable

    });

    this.showBookingPopup = true;
    this.showAddressSlider = false;
    this.showGstSecondSlider = false;
    this.gstDetails = false;

    // Now call the method
    
  }
  // this.confirmGarageCustomerDetails();
}

// onCreateCustomer() {
//   if (this.addressForm.valid) {
//     const name = this.addressForm.value.name;

//     this.customerName = name;
//     this.currentTime = new Date();
//     // this.confirmGarageCustomerDetails();
//     this.showBookingPopup = true;

//     // Optional: submit form, update booking, etc.
//   }
//   this.confirmGarageCustomerDetails();
// }


closePopup() {
  this.showBookingPopup = false;
}

closeSidebar(ishide: boolean): void {
  this.isVisible = ishide;
  this.isConfirmationSidebarOpen = false;
  if (localStorage.getItem('customer-list') && localStorage.getItem('customer-list') === '1') {
    localStorage.removeItem('customer-list');
    localStorage.removeItem('rowKey');
    localStorage.removeItem('selectedMake');
    localStorage.removeItem('selectedModel');
    localStorage.removeItem('selectedYear');
    localStorage.removeItem('variant');
    localStorage.removeItem('variantKey');
    localStorage.removeItem('fuelType');
    localStorage.removeItem('name');
    localStorage.removeItem('odometer');
    localStorage.removeItem('phoneNumber');
  }
}
closeAll(){
  this.closeSidebar(true);
  this.isVisible = false;
//   this.customerDetailsANDcarDetails=false;
// this.fuelAccessoriesContainer = false;
this.gstDetails = false;
this.showGstSecondSlider = false;
this.showBusinessInfoSlider = false;
this.showAddressSlider = false;
this.isJobCardSidebarOpen = false;
this.showAddressSlider = false;
}
onRegDecodeSubmit(): void {
  this.isManualSelection = false;
  this.formSubmitted = true;
  
  this.vehicleForm1.markAllAsTouched();
  if (this.vehicleForm1.valid) {
    this.aspLoadingService.show();
    const regNo = this.vehicleForm1.get('regNo')?.value.replace(/\s/g, '');
    const odometer = this.vehicleForm1.get('odometer')?.value;
    const phoneNumber = this.vehicleForm1.get('phoneNumber')?.value;
    const name = this.vehicleForm1.get('name')?.value;
    const garageKey=localStorage.getItem("garageKey")
    // console.log("garageKey")
    this.sideBarJobcardService.regDecode(regNo,garageKey).subscribe(
      (res: any) => {
        // console.log("sidebarjobcard-response",res);
        this.aspLoadingService.hide();
         if ( res.data && res.code == 200 ) {
        this.jobCard = {
          make: res.data.make,
          registrationNumber: res.data.registrationNumber,
          model: res.data.model,
          variant: res.data.variant,
          mfgYear: res.data.year,
          fuelType: res.data.fuel,
          vin: res.data.vin,
          ExistingCustomer:res.data.isExistingCustomer
        };
        // console.log("ExistingCustomer--",this.jobCard.ExistingCustomer);
         localStorage.setItem('selectedMake',res.data.make)
         localStorage.setItem('selectedModel',res.data.model)
         localStorage.setItem('selectedYear',res.data.year)
         localStorage.setItem('fuelType',res.data.fuel)
         localStorage.setItem('vin',res.data.vin)
         localStorage.setItem('variant',res.data.variant)
         localStorage.setItem('registrationNumber',res.data.registrationNumber)
        localStorage.setItem('carSize', res.data.carSize || '');
        this.vehicleForm1.patchValue({
          rowKey: res.data.rowKey,
          variantKey: res.data.variantKey,
        });
        const bookingId = res.data.bookingId;
        // this.fetchPreFilledBooking(res.data.registrationNumber, bookingId);
        this.isVisible = false;
        this.isConfirmationSidebarOpen = true;
        this.jobCardDetails=true;
      } else {
              this.toastr.error('Car Details Not Found. Please Select Car Manually.');
              this.isConfirmationSidebarOpen = false;
            }
          },
      
      (error: any) => {
        console.error('Error:', error);
        this.aspLoadingService.hide();
      }
    );
  } else {
    this.vehicleForm1.markAllAsTouched();
  }
}  

  redirectToManualSelection(): void {
    this.formSubmitted = true;
    this.vehicleForm1.markAllAsTouched();
    // if (this.isManualSelectionValid()) {

      localStorage.setItem('name', this.vehicleForm1.get('name')?.value);
      localStorage.setItem('phoneNumber', this.vehicleForm1.get('phoneNumber')?.value);
      // localStorage.setItem('odometer', this.vehicleForm1.get('odometer')?.value);
      localStorage.setItem('customer-list', '1');
      this.router.navigate(['/make']);
      this.isConfirmationSidebarOpen = true;
    // } 
    // else{
    //   this.vehicleForm1.markAllAsTouched(); 
    //   // }
  }

// fetchPreFilledBooking(registrationNumber, bookingId: string): void {
//   // const registrationNumber = "registrationNumber";
//   const garageKey = localStorage.getItem('garageKey');
//   this.sideBarJobcardService.getPreFilledBooking(registrationNumber, garageKey, this.bookingId).subscribe(
//     res => {
//       console.log("bookingid", this.bookingId);
//       console.log('Fetched pre-filled booking data:', res);
//       if (res && res.data) {
//         this.customer.name = res.data.name;
//         this.customer.mobile = res.data.mobile;
//         this.customer.email = res.data.email;
//         this.car.vin = res.data.vin;
//         this.car.engineNumber = res.data.engineNumber;
//         this.showServiceHistory = true; // Show the button if response exists
//         this.isExistingCustomer=res.data.existingCustomer;
//         console.log("this.isExistingCustomer----",this.isExistingCustomer);
//       } else {
//         this.showServiceHistory = false; // Hide the button if no response data
//       }
//     },
//     error => {
//       console.error('Error fetching booking data:', error);
//       this.showServiceHistory = false;
//     }
//   );
// }

 @HostListener('document:click', ['$event'])
  onClickOutside(event: MouseEvent) {
    const clickedInside = this.elementRef.nativeElement.contains(event.target);
    if (!clickedInside && this.isVisible) {
      this.closeSidebar(true);
      this.isVisible = true;
    }
  }
  closeCreateCustomerSlider() {
    this.isCreateCustomerSliderOpen = false;
     this.gstDetails = true;
  }
  // createCustomer() {
  //   if (this.customerForm.valid) {
  //     const customerData = this.customerForm.value;
  //     // Proceed to the next step with the customer data
  //     this.isCreateCustomerSliderOpen = false;
  //     this.showBookingPopup = true;
  //   } else {
  //     alert('Please fill all required fields');
  //   }
  //   this.confirmGarageCustomerDetails();
  // }
  // confirmGarageCustomerDetails(): void {
  //   const gstDetailsRaw = {
  //     gstNumber: this.customerGstForm.value.gstNumber || null,
  //     addressLine1: this.addressForm.value.addressLine1 || null,
  //     addressLine2: this.addressForm.value.addressLine2 || null,
  //     city: this.addressForm.value.city || null,
  //     pincode: this.addressForm.value.pincode || null,
  //     state: this.customerGstForm.value.state || null,
  //     companyName: this.customerGstForm.value.businessName || null
  //   };
  
  //   const isGstDetailsEmpty = Object.values(gstDetailsRaw).every(value => !value);
  
  //   const payload = {
  //     garageKey: localStorage.getItem('garageKey') || null,
  //     vehicleDetail: {
  //       registrationNumber: this.vehicleForm1.value.regNo || null,
  //       make: this.jobCard?.make || null,
  //       model: this.jobCard?.model || null,
  //       variant: this.jobCard?.variant || null,
  //       rowKey: this.vehicleForm1.value.rowKey || null,
  //       variantKey: this.vehicleForm1.value.variantKey || null,
  //       manufactureYear: this.jobCard?.mfgYear || null,
  //       fuelType: this.jobCard?.fuelType || null,
  //       vinNumber: this.jobCard?.vin || null
  //     },
  //     customerName: this.customerForm.value.name || null,
  //     mobileNumber: this.customerForm.value.mobile || null,
  //     email: this.customerForm.value.email || null,
  //     gstDetails: isGstDetailsEmpty
  //       ? null
  //       : {
  //           ...gstDetailsRaw,
  //           address: `${gstDetailsRaw.addressLine1 || ''}, ${gstDetailsRaw.addressLine2 || ''}, ${gstDetailsRaw.city || ''} - ${gstDetailsRaw.pincode || ''}`.replace(/^, | ,| - $/g, '').trim()
  //         }
  //   };
  
  //   console.log('Final Payload:', payload);
  
  //   // this.aspLoadingService.show();
  
  //   this.aspCustomerListService.createGarageCustomer(payload).subscribe(
  //     (response: any) => {
  //       if (response && response.code === 200) {
  //         console.log('Garage Customer created:', response);
  //         this.isConfirmationSidebarOpen = false;
  //       } else {
  //         console.error('Unexpected response:', response);
  //         this.toastr.error('Failed to create customer. Please try again.');
  //       }
  //     },
  //     (error: any) => {
  //       // this.aspLoadingService.hide();
  //       console.error('Server error:', error);
    
  //       // Log full error details
  //       console.error('Error status:', error.status);
  //       console.error('Error message:', error.message);
  //       console.error('Error response:', error.error);
    
  //       this.toastr.error('Server error while creating customer.');
  //     }
  //   );
    
  // }
  createCustomer() {
    // if (this.customerForm.valid) {
      // do your customer creation logic here
  
      // finally call confirmGarageCustomerDetails only after valid form
      this.confirmGarageCustomerDetails();
      
    // }
  }
  
  confirmGarageCustomerDetails(): void {
     if (this.customerForm.invalid) {
    this.customerForm.markAllAsTouched();
    return;
  }

    const gstDetailsRaw = {
      gstNumber: this.customerGstForm.value.gstNumber || null,
      addressLine1: this.addressForm.value.addressLine1 || null,
      addressLine2: this.addressForm.value.addressLine2 || null,
      city: this.addressForm.value.city || null,
      pincode: this.addressForm.value.pincode || null,
      state: this.customerGstForm.value.state || null,
      companyName: this.customerGstForm.value.businessName || null
    };
  
    const isGstDetailsEmpty = Object.values(gstDetailsRaw).every(value => !value);
  
    const payload = {
      garageKey: localStorage.getItem('garageKey') || null,
      vehicleDetail: {
        registrationNumber: this.vehicleForm1.get('regNo')?.value.replace(/\s/g, ''),
        make: this.jobCard?.make || null,
        model: this.jobCard?.model || null,
        variant: this.jobCard?.variant || null,
        rowKey: this.vehicleForm1.value.rowKey || null,
        variantKey: this.vehicleForm1.value.variantKey || null,
        manufactureYear: this.jobCard?.mfgYear || null,
        fuelType: this.jobCard?.fuelType || null,
        vinNumber: this.jobCard?.vin || null,
        carSize: localStorage.getItem('carSize') || null 
      },
      customerName: this.customerForm.get('name')?.value || null,
      mobileNumber: this.customerForm.get('mobile')?.value || null,
      email: this.customerForm.get('email')?.value || null,
      rateCardApplicable: this.customerForm.get('rateCardApplicable')?.value || 'default', 
      gstDetails: isGstDetailsEmpty
        ? null
        : {
            ...gstDetailsRaw,
            address: `${gstDetailsRaw.addressLine1 || ''}, ${gstDetailsRaw.addressLine2 || ''}, ${gstDetailsRaw.city || ''} - ${gstDetailsRaw.pincode || ''}`.replace(/^, | ,| - $/g, '').trim()
          }
    };
  
    // console.log('Final Payload:', payload);
  
    this.aspCustomerListService.createGarageCustomer(payload).subscribe(
      (response: any) => {
        this.aspLoadingService.show();
        if (response && response.code === 200) {
          this.aspLoadingService.hide();
          // console.log('Garage Customer created:', response);
          // Store customerId here
          this.customerID = response.customerId || response.data?.customerId || null;
          this.closeCreateCustomerSlider();
          this.isConfirmationSidebarOpen = false;
          this.showBookingPopup = true;
          this.showAddressSlider = false;
          this.gstDetails = false;
          this.ngOnInit();
        } else {
          console.error('Unexpected response:', response);
          this.toastr.error('Failed to create customer. Please try again.');
        }
         
      },
      (error: any) => {
        console.error('Server error:', error);
        this.toastr.error('Server error while creating customer.');
      }
    );
  }
  // fetchAllCustomers(): void {
  //   this.aspCustomerListService.getAllCustomers().subscribe(
  //     (response) => {
  //       if (response.code === 200) {
  //         console.log('Customer List:', response.data);
  //         // handle customer data here
  //       } else {
  //         console.warn('Error fetching customers:', response.message);
  //       }
  //     },
  //     (error) => {
  //       console.error('API Error while fetching customers:', error);
  //     }
  //   );
  // }
  fetchAllCustomers(): void {
    this.aspLoadingService.show();
    this.aspCustomerListService.getAllCustomers().subscribe(
      (response) => {
        this.aspLoadingService.hide();
        if (response.code === 200) {
          this.customerList = response.data.customers;
          this.originalCustomerList = response.data.customers;
        this.customerList = [...this.originalCustomerList]; // initialize filtered list
          // console.log('Customer List:', this.customerList);
        } else {
          console.warn('Error fetching customers:', response.message);
        }
      },
      (error) => {
        console.error('API Error while fetching customers:', error);
      }
    );
  }
  loadCustomers() {
    // Example: Fetch and set the customer list
    this.customerList = [/* your data */];
    this.filteredCustomerList = this.customerList; // initially show all
  }
  
  filterRequests(): void {
    const search = this.searchText?.toLowerCase() || '';
  
    if (!search) {
      this.customerList = [...this.originalCustomerList]; 
      return;
    }
  
    this.customerList = this.originalCustomerList.filter(customer =>
      customer.customerId?.toString().includes(search) ||
      customer.name?.toLowerCase().includes(search) ||
      customer.mobile?.includes(search) ||
      customer.gstNumber?.toLowerCase().includes(search)
    );
  }
  
  clearSearch(): void {
    this.searchText = '';
    this.customerList = [...this.originalCustomerList]; 
  }
  onSearch() {
    this.filterRequests(); 
  }
  clearFilters(): void {
    this.searchText = '';
    this.customerList = [...this.originalCustomerList];

    localStorage.removeItem('customerFilter');
  
    // console.log('Filters cleared. Showing full customer list.');
  }
  
  fetchRateCardTypes(): void {
  const garageKey = localStorage.getItem('garageKey');
  if (!garageKey) {
    console.warn('Garage key not found in local storage.');
    return;
  }

  this.sideBarJobcardService.getRateCardByGarageKey(garageKey).subscribe(
    (response) => {
      if (response.code === 200) {
        this.ratecardTypes = response.data.rateCardTypes;
      } else {
        console.warn('Error fetching rate card types:', response.message);
      }
    },
    (error) => {
      console.error('API Error while fetching rate card types:', error);
    }
  );
}
}
